<template>
  <b-modal
    id="modal-expense"
    :title="isEdit ? 'Edit Expense' : 'New Expense'"
    hide-footer
    no-close-on-esc
    no-close-on-backdrop
  >
    <validation-observer
      ref="form"
      slim
    >
      <b-row>
        <b-col>
          <validation-provider
            name="Type"
            rules="required"
            v-slot="{ errors }"
          >
            <b-form-group
              label="Type"
              :invalid-feedback="errors[0]"
            >
              <custom-select
                v-model="addExpenseForm.budgetTypeId"
                label="typeName"
                :options="typeOption"
                @input="fetchActivityList(addExpenseForm.budgetTypeId)"
                @search="fetchTypeList($event, true)"
                :class="{ 'is-invalid': errors.length }"
                :reduce="({ id }) => id"
              />
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <validation-provider
            name="Activity"
            rules="required"
            v-slot="{ errors }"
          >
            <b-form-group
              label="Activity"
              :invalid-feedback="errors[0]"
            >
              <custom-select
                v-model="addExpenseForm.activityId"
                label="name"
                :options="activityOption"
                :class="{ 'is-invalid': errors.length }"
              />
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <validation-provider
            name="Transaction Date"
            v-slot="{ errors }"
          >
            <b-form-group
              label="Date"
              :invalid-feedback="errors[0]"
            >
                <b-form-datepicker
                v-model="addExpenseForm.transactionDate"
                :class="{ 'is-invalid': errors.length }"
              />
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
        <validation-provider
            name="Descriptions"
            rules="max:255"
            v-slot="{ errors }"
          >
          <b-form-group
            label="Descriptions"
            :invalid-feedback="errors[0]"
          >
            <b-form-textarea
              v-model="addExpenseForm.description"
              placeholder="Enter Descriptions"
              rows="4"
              :class="{ 'is-invalid': errors.length }"
              max-rows="6"
            />
          </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <validation-provider
            name="Amount"
            rules="required|min_value:0"
            v-slot="{ errors }"
          >
            <b-form-group
              label="Amount"
              :invalid-feedback="errors[0]"
            >
              <b-input-group
                prepend="Rp"
                :class="{ 'is-invalid': errors.length }"
              >
                <money
                  class="form-control"
                  :class="{ 'is-invalid': errors.length }"
                  v-model="addExpenseForm.billAmount"
                  placeholder="0"
                />
              </b-input-group>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group
            label="Upload Bills"
          >
            <div class="dropbox_e">
              <input
                type="file"
                accept=".pdf, jpeg, png, jpg, bmp"
                model="file"
                placeholder="select file"
                @change="onFileChange"
                class="input-file_e"
              />
              <div id="preview" class="mt-1">
                <img
                  src="@/assets/fi_upload.png"
                  class="icon-style"
                />
              </div>
            </div>
            <br/>
            <label class="text-upload">*Maximum file upload 10MB</label>
            <br>
            <label class="text-upload">**Format file can be .pdf or image</label>
            <br/>
            <div class="mt-2 text-upload">
              <b-row
                v-if="file || (addExpenseForm.expenseBills && addExpenseForm.expenseBills.length)"
                class="d-flex ml-1"
              >
                <div
                  v-if="file"
                  class="name-file"
                >
                  {{ file ? file.name : null }}
                </div>
                <div
                  v-else-if="addExpenseForm.expenseBills.length"
                  class="name-file"
                >
                  {{ addExpenseForm.expenseBills ? addExpenseForm.expenseBills[0].originalFilename : null }}
                </div>
                <div
                  v-if="(file && file.name) || (addExpenseForm.expenseBills.length)"
                  align="right"
                >
                  <img
                    src="@/assets/Light.png"
                    v-on:click="cancelUpload()"
                    class="icon"
                    style="cursor: pointer;"
                  />
                </div>
              </b-row>
            </div>
            <br/>
          </b-form-group>
        </b-col>
      </b-row>
    </validation-observer>
    <b-button
      class="primary shadow"
      variant="warning"
      block
      @click="submit"
    >
      Save
    </b-button>
  </b-modal>
</template>

<script>
import api from '@/api'

export default {
  components: {
  },
  props: {
    addExpenseForm: {
      type: Object,
      default: () => ({})
    },
    isEdit: {
      type: Boolean,
      default: () => false
    },
    activityOption: {
      type: Array,
      default: () => ([])
    }
  },
  data: () => ({
    file: null,
    fileUrl: null,
    documentName: null,
    documentDesc: null,
    fileUploads: null,
    fileUploadPreview: null,
    typeOption: []
  }),

  created() {
    this.fetchTypeList('', false)
  },

  methods: {
    async fetchActivityList(type) {
      this.addExpenseForm.activityId = null
      this.activityOption = await this.typeOption.find(element => element.id === type).budgetActivities || []
    },
    async fetchTypeList(keyword, onSearch) {
      let data = []
      if (onSearch && keyword.length >= 3) {
        data = await api.budget.type(
          {
            Filters: `typeName@=*${keyword}`,
            Sorts: 'typeName',
            Page: 1,
            PageSize: 10
          }
        )
      } else {
        data = await api.budget.type(
          {
            Filters: `typeName@=*${keyword}`,
            Sorts: 'typeName',
            Page: 1,
            PageSize: 10
          }
        )
      }
      this.typeOption = data.data.data
      this.addExpenseForm.activityId = null
      this.activityOption = []
    },
    onFileChange(e) {
      const file = e.target.files[0]
      this.addExpenseForm.file = file
      this.file = file
      var size = parseFloat(this.addExpenseForm.file.size / (1024 * 1024)).toFixed(2)
      if (size > 10) {
        this.$bvToast.toast('Please select file size less than 10 MB', {
          headerClass: 'd-none',
          solid: true,
          variant: 'danger'
        })
        this.addExpenseForm.file = null
        this.file = null
      } else {
        var check = file.name.split('.').pop()
        const arrDocType = ['pdf', 'jpeg', 'png', 'jpg', 'bmp']
        if (arrDocType.includes(check.toLowerCase())) {
          this.isProposalNo = false
          this.$bvToast.toast('Success browse file', {
            headerClass: 'd-none',
            solid: true,
            variant: 'success'
          })
        } else {
          this.addExpenseForm.file = null
          e = ''
          this.$bvToast.toast('Only pdf, image files are allowed!', {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
        }
      }
    },
    cancelUpload() {
      this.file = null
      this.addExpenseForm.expenseBills = []
    },
    async submit() {
      const valid = await this.$refs.form.validate()
      if (!valid) {
        this.isBusy = false
        return false
      }

      if (this.file) {
        this.addExpenseForm.file = this.file
        this.addExpenseForm.billId = null
        this.addExpenseForm.expenseBills = []
      } else {
        this.file = null
        this.addExpenseForm.file = null
        if (this.addExpenseForm.expenseBills && this.addExpenseForm.expenseBills.length) this.addExpenseForm.billId = this.addExpenseForm.expenseBills[0].id
        else this.addExpenseForm.billId = null
      }

      this.addExpenseForm.activity_id = this.addExpenseForm.activityId.id
      this.$emit('set', this.addExpenseForm)
      this.file = null
    }
  }
}
</script>

<style lang="scss" scoped>
.col, .col-2, .col-3, .col-6 {
  padding: 0 16px;
}
.dropbox_e {
  border: 2px solid #D3D3D3;
  text-align: right;
}
.input-file_e {
  margin-top: -2px;
  margin-left: -455px;
  opacity: 0;
  width: 460px;
  height: 30px;
  position: absolute;
  cursor: pointer;
}

.icon-style {
  width: 15px;
  margin-top: -9px;
  margin-right: 5px;
}

.name-file {
  width: 430px;
}
</style>
